<div #feedbackContainer class="upload-feedback" *ngIf="messages.length > 0">
  <div *ngFor="let msg of messages" class="feedback-message">
    {{ msg }}
  </div>
</div>

<div class="upload-form">
  <div class="information">
    <ol>
      <li>{{ "uploadData.uploadInfo.1" | translate }}</li>
      <li>{{ "uploadData.uploadInfo.2" | translate }}</li>
    </ol>
  </div>

  <!-- Metadata upload -->
  <div class="form-card" *ngIf="canUploadMetadata">
    <div class="form-header">
      <h2 class="form-title">
        {{ "uploadData.metadata.title" | translate }}
      </h2>

      <a class="template-button" href="app/shared/assets/files/metadata_import_template.xlsx" download>
        {{ "uploadData.downloadTemplate" | translate }}
      </a>
    </div>

    <div class="form-grid form-grid-one">
      <!-- Metadata Upload -->
      <div
        class="upload-zone"
        role="button"
        tabindex="0"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDropMetadata($event)"
      >
        <div class="drop-area">
          <lucide-angular name="upload" [size]="48" class="upload-icon"></lucide-angular>
          <div class="drop-text">{{ "uploadData.msg.drag" | translate }}</div>
          <button
            class="upload-button"
            type="button"
            (click)="triggerMetadataFileInput()"
            (keydown.enter)="triggerMetadataFileInput()"
            (keydown.space)="triggerMetadataFileInput()"
          >
            {{ "button.chooseFile" | translate }}
          </button>

          <div class="form-hint">{{ "uploadData.metadata.upload" | translate }}</div>
        </div>

        <input type="file" #metadataInput accept=".csv,.tsv" hidden (change)="handleMetadataFile($event)" />
      </div>
    </div>
  </div>

  <!-- RNA and mutation upload -->
  <div class="form-card" *ngIf="canUploadRnaMutation">
    <app-rna-mutation-upload (messagesChanged)="messages = $event" (uploadingChange)="isUploading = $event">> </app-rna-mutation-upload>
  </div>
</div>

<div class="modal-backdrop" *ngIf="isUploading">
  <div class="loader-container">
    <div class="dots-row">
      <div class="dot" *ngFor="let dot of dots" [@fadeInOut]></div>
    </div>
    <div class="loader-text">{{ "uploadData.fileUploading" | translate }}</div>
  </div>
</div>
